import { WildberriesProductCardsModalConfig } from "../types/wildberries-product-cards-modal.type";
import {
  ProductCardGroupModalComponent
} from "../components/product-card-group-modal/product-card-group-modal.component";


const wildberriesProductCardsFieldConfig = {
  productCardGroupModalDto: {
    component: ProductCardGroupModalComponent,
    width: '90vw'
  }
} as const;

export const wildberriesProductCardsModalConfig: Record<string, WildberriesProductCardsModalConfig> =
  Object.fromEntries(
    Object.entries(wildberriesProductCardsFieldConfig).map(([fieldName, config]) => [
      fieldName,
      {
        ...config,
        fieldName
      }
    ])
  );
